import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "image-card" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "fallback"
}
const _hoisted_4 = { class: "overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "checkbox",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selected && _ctx.selected(...args)), ["stop"]))
    }, [
      (_ctx.isSelectedMode)
        ? (_openBlock(), _createBlock(_component_AppCheckbox, {
            key: 0,
            modelValue: _ctx.selectedImage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedImage) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.error)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.src,
          alt: _ctx.alt,
          style: _normalizeStyle({ objectFit: _ctx.fit }),
          loading: "lazy",
          class: _normalizeClass({ 'fade-in': _ctx.loaded }),
          onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onError && _ctx.onError(...args))),
          onLoad: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onLoad && _ctx.onLoad(...args)))
        }, null, 46, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "fallback", {}, () => [
            _cache[4] || (_cache[4] = _createTextVNode("⚠️ Ошибка загрузки", -1))
          ], true)
        ])),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}